import type { Period } from "@/utils/period";

const FIELD =
  "rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-sm focus:outline-none";

interface Props {
  value: Period;
  onChange: (period: Period) => void;
}

export default function PeriodFilter({ value, onChange }: Props) {
  const set = (patch: Partial<Period>) => onChange({ ...value, ...patch });
  return (
    <div className="flex flex-wrap items-center gap-2">
      <select
        value={value.mode}
        onChange={(e) => set({ mode: e.target.value as Period["mode"] })}
        className={`${FIELD} cursor-pointer`}
        aria-label="Période"
      >
        <option value="all">Toutes les dates</option>
        <option value="month">Un mois</option>
        <option value="range">Entre deux dates</option>
      </select>
      {value.mode === "month" && (
        <input
          type="month"
          value={value.month}
          onChange={(e) => e.target.value && set({ month: e.target.value })}
          className={FIELD}
          aria-label="Mois"
        />
      )}
      {value.mode === "range" && (
        <>
          <input
            type="date"
            value={value.from}
            max={value.to || undefined}
            onChange={(e) => set({ from: e.target.value })}
            className={FIELD}
            aria-label="Du"
          />
          <span className="text-xs text-foreground-500">au</span>
          <input
            type="date"
            value={value.to}
            min={value.from || undefined}
            onChange={(e) => set({ to: e.target.value })}
            className={FIELD}
            aria-label="Au"
          />
        </>
      )}
    </div>
  );
}
